import React from 'react'
import { Ordering } from 'storfox-filter'

import { INVOICE_COLUMNS as tableColumns } from './InvoiceTable'

import { FILTER_NAME as name } from '../../constants'

export const invoiceOrderingOptions = {
  name,
  tableColumns
}

function InvoiceOrderingForm (props) {
  return (
    <Ordering {...props} />
  )
}

export default InvoiceOrderingForm
